<script>
   /**************************************************************/
   /* ResultsTable                                               */
   /* -------------------------                                  */
   /* shows table with SIMCA results for new dataset             */
   /**************************************************************/

   // main properties of the whole app
   let { res, ncomp } = $props();
</script>


{#if res}
<table>
   <thead>
   <tr>
      <th></th>
      <th>New</th>
   </tr>
   </thead>
   <tbody>
   <tr>
      <td class="label">Objects</td>
      <td>{res.v[0].decs.length}</td>
   </tr>
   <tr>
      <td class="label">In</td>
      <td>{res.v[ncomp - 1].decsNum.in}</td>
   </tr>
   <tr>
      <td class="label">Out</td>
      <td>{res.v[ncomp - 1].decsNum.out}</td>
   </tr>
   </tbody>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>